// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AccountType } from '@shared/utils/cache/Accounts/Account.types';
import { DataCache } from '../../DataCache';
class _TvAccountHelper {
    constructor() {
        this.fakeAccountId = 'fakeId';
    }
    getCurrentAccount() {
        return this.currentAccount;
    }
    setCurrentAccount(account) {
        this.currentAccount = account;
    }
    resetCurrentAccount(id) {
        const savedAccount = DataCache.Accounts[id];
        this.setCurrentAccount(savedAccount !== null && savedAccount !== void 0 ? savedAccount : this.getDefaultAccount());
    }
    getCurrentAccountId() {
        var _a, _b;
        return (_b = (_a = this.currentAccount) === null || _a === void 0 ? void 0 : _a.BstrAccount) !== null && _b !== void 0 ? _b : this.fakeAccountId;
    }
    getFakeAccountId() {
        return this.fakeAccountId;
    }
    setAccountById(id) {
        this.setCurrentAccount(DataCache.Accounts[id]);
    }
    getDefaultAccount() {
        let curAccount = DataCache.MainAccountNew;
        if (curAccount.AccountType === AccountType.SingleCCY) {
            return curAccount;
        }
        curAccount = curAccount.User.Accounts.find((acc) => acc.AccountType === AccountType.SingleCCY);
        if (!isNullOrUndefined(curAccount)) {
            return curAccount;
        }
        const accounts = DataCache.Accounts;
        for (const accID in accounts) {
            const account = accounts[accID];
            if (account.AccountType === AccountType.SingleCCY) {
                return account;
            }
        }
        return null;
    }
}
export const TvAccountHelper = new _TvAccountHelper();
